import { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import SignatureService from "../../services/SignatureService";
import { QuestionsErrorModal } from "../Modals/QuestionsErrorModal/QuestionsErrorModal";
import { useTranslation } from 'react-i18next';
import { shouldShowSignerDataAfterPreview } from "../../util/signerDataDisplay";
import { FIRST_LOAD } from "../../constants/GeneralConstants";

export const FormOnPreview = ({ emailId, setLoadingMorePages, areQuestionsAnswered, startCorrectSignMethod, signerGuid, formTransform, form, setFormOnPreview, formOnPreviewError, isAutofirma, setAutofirma, documents, setOpenWalletOptionalModal }) => {
    const [openQuestionErrorModal, setOpenQuestionErrorModal] = useState(false);
    const navigate = useNavigate();
    const { t } = useTranslation();
    const errorMessageModal = t('document_id.file_size_limit_exceeded');
    
    useEffect(() => {
        const canContinue = areQuestionsAnswered();
        if (!canContinue) {
            setOpenQuestionErrorModal(true);
            return;
        }

        const array = [].concat(...formTransform);
        let result = [].concat(...array.map(val => val.components.map(comp => {
        return { id: comp.id, response: ((comp.response === undefined || comp.response === null) ? comp.selectedchoice : comp.response) };
        })));
        result = result.filter(val => val.response !== undefined);
        setLoadingMorePages(true);
        SignatureService.signatureFormResponse(signerGuid, form, result, true)
        .then(() => {
            // SignerData AfterPreview must appear after OnPreview Form (acceptance)
            if (shouldShowSignerDataAfterPreview(documents?.SignerDTO?.SignerData)) {
                setLoadingMorePages(false);
                // Mark as no longer the first load so that DocumentPreview does NOT call
                // deleteDocumentRendered (which would wipe the saved form answers) when it
                // re-mounts after SignerData is submitted.
                localStorage.setItem(FIRST_LOAD, "false");
                navigate("/signer-data", {
                    state: {
                        documents,
                        emailId,
                        // Return directly to DocumentPreview (not /document-questions) so the
                        // user auto-continues to sign without re-visiting the questions page.
                        returnTo: "/document",
                        autoContinueToSign: true,
                        skipSignerDataCheck: true,
                        // avoid showing the onPreview form again when auto-continuing
                        skipOnPreviewForm: true,
                    }
                });
                return;
            }

            // Autofirma
            if (typeof isAutofirma !== 'undefined' && isAutofirma !== 'no') return setAutofirma(true);

            // Wallet optional flow
            if (documents.SignerDTO.Wallet?.toLowerCase() === "optional") return setOpenWalletOptionalModal(true);

            startCorrectSignMethod();
        })
        .catch(err => {
            setLoadingMorePages(false);
            const errorMessage = err.response.data;
            if (errorMessage.includes('bigger') || errorMessage.includes('greater')) {
                setFormOnPreview(false);
                formOnPreviewError(errorMessageModal);
            }
        });
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);

    return (
        <QuestionsErrorModal setOpenQuestionErrorModal={setOpenQuestionErrorModal} openQuestionErrorModal={openQuestionErrorModal} setFormOnPreview={setFormOnPreview} isAdvancedForm={true} />
    );
};
